import { useNavigate } from 'react-router-dom';
import { useCurrentWorkspaceUrlPrefix } from '@tinct/core-workspace';
import { useStaticAssetsUrl, cn } from '@tinct/core-utils';
import { Button } from '@tinct/web-components';

export type SnippetConnectBannerProps = {
  className?: string;
};

export function SnippetConnectBanner({ className }: SnippetConnectBannerProps) {
  const navigate = useNavigate();
  const workspaceBaseUrl = useCurrentWorkspaceUrlPrefix();
  const assetsUrl = useStaticAssetsUrl();

  return (
    <div
      className={cn(
        'relative flex items-center overflow-hidden rounded-2xl border border-white/10 bg-amber-300 p-6 md:pr-96',
        className,
      )}
    >
      <div className="flex max-w-xl flex-1 flex-col gap-4">
        <div className="flex flex-col gap-2">
          <p className="font-heading text-lg font-semibold leading-[26px] tracking-tight text-foreground">
            One last step — connect your tracking snippet
          </p>
          <p className="text-sm leading-5 text-foreground">
            This tracking snippet works across your entire website and enables
            personalization for all your campaigns. You only need to install it
            once.
          </p>
        </div>
        <div>
          <Button
            variant="accent"
            onClick={() => navigate(`${workspaceBaseUrl}/settings/snippet`)}
          >
            Connect your snippet
          </Button>
        </div>
      </div>
      <img
        src={`${assetsUrl}/snippet-connect-banner.png`}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute inset-y-0 right-0 hidden h-full w-auto md:block"
      />
    </div>
  );
}
